<template>
  <div class="moderator-marketing-testing">
    <div v-if="pending"
         style="min-height: 20rem; position: relative">
      <BasePreloader/>
    </div>
    <ErrorView v-else-if="error"
               :code="error.code"
               :title="error.message"
               class="container-inner"/>
    <div v-if="receivedData"
         class="moderator-marketing-testing__content">
      <BasePreloader v-if="fromPending"/>

      <div class="moderator-marketing-testing__massages">
        <div class="moderator-marketing-testing__massage">
          <BaseInput v-model="inputs.sms.value"
                     :label="$tModeratorMarketingTesting('message_sms')"
                     :error="inputs.sms.error"
                     textarea/>
        </div>

        <div class="moderator-marketing-testing__massage">
          <BaseInput v-model="inputs.bot.value"
                     :label="$tModeratorMarketingTesting('message_bot')"
                     :error="inputs.bot.error"
                     textarea/>
          <BaseInput v-model="inputs.link_to_bot.value"
                     :error="inputs.link_to_bot.error"
                     :label="$tModeratorMarketingTesting('link_to_bot')"
                     style="margin-top: 2rem"/>
        </div>

        <div class="moderator-marketing-testing__massage">
          <BaseInput v-model="inputs.site.value"
                     :label="$tModeratorMarketingTesting('message_site')"
                     :error="inputs.site.error"
                     textarea/>
        </div>

        <template>
          <div class="moderator-marketing-testing__massage">
            <div class="moderator-marketing-testing__inputs-wrap">
              <BaseInput v-model="inputs.email_title.value"
                         :error="inputs.email_title.error"
                         :label="$tModeratorMarketingTesting('email_title')"
                         class="moderator-marketing-testing__input"/>
              <BaseInput v-model="inputs.email_subject.value"
                         :error="inputs.email_subject.error"
                         :label="$tModeratorMarketingTesting('email_subject')"
                         class="moderator-marketing-testing__input"/>
              <BaseInput v-model="inputs.email_link.value"
                         :error="inputs.email_link.error"
                         :label="$tModeratorMarketingTesting('email_link')"
                         class="moderator-marketing-testing__input"/>
            </div>
            <div class="input__label">
              {{ $tModeratorMarketingTesting('message_email') }}
            </div>
            <Editor v-model="inputs.email.value"/>
            <BaseInputError :value="inputs.email.error"/>
          </div>
        </template>


        <div class="moderator-marketing-testing__massage">
          <div class="moderator-marketing-testing__inputs-wrap">
            <BaseInput v-model="inputs.messenger.value"
                       :label="$tModeratorMarketingTesting('messenger')"
                       :error="inputs.messenger.error"
                       style="width: 100%"
                       textarea/>
          </div>

          <div class="moderator-marketing-testing__inputs-wrap">
            <BaseInput v-model="inputs.messenger_link.value"
                       :error="inputs.messenger_link.error"
                       :label="$tModeratorMarketingTesting('messenger_link')"
                       style="flex-grow: 1"
                       class="moderator-marketing-testing__input"/>
          </div>
          <div class="input__label">
            {{ $tModeratorMarketingTesting('messenger_image') }}
          </div>
          <FilesUploadMultiple v-model="messengerImage"
                               :max="1"
                               :filesExtsMixin="filesExtsMixin"
                               :filesMimeTypes="filesMimeTypes"
                               class="moderator-marketing-testing__input-upload"/>
          <BaseInputError :value="inputs.email.error"/>
        </div>
      </div>


      <div class="moderator-marketing-testing__persons">
        <BaseSelect :label="$tModeratorMarketingTesting('Customer')"
                    v-model="inputs.customer_id.value"
                    :error="inputs.admin_id.error"
                    text-key="label"
                    cancelable
                    :options="receivedData.customers"
                    class="moderator-marketing-testing__person"/>
        <BaseSelect :label="$tModeratorMarketingTesting('Moderator')"
                    v-model="inputs.admin_id.value"
                    :error="inputs.admin_id.error"
                    text-key="label"
                    cancelable
                    :options="receivedData.moderators"
                    class="moderator-marketing-testing__person"/>
      </div>

      <div style="border-bottom: 0"
           class="moderator-marketing-testing__massage">
        <div class="moderator-marketing-testing__checkboxes-wrap">
<!--          <div class="moderator-marketing-testing__checkbox">-->
<!--            <BaseCheckbox v-model="inputs.send_link_bot.value"-->
<!--                          :error="inputs.send_link_bot.error"-->
<!--                          :label="$tModeratorMarketingTesting('send_link_bot')"/>-->
<!--            <BaseInputError :value="inputs.send_link_bot.error"/>-->
<!--          </div>-->
<!--          <div class="moderator-marketing-testing__checkbox">-->
<!--            <BaseCheckbox v-model="inputs.send_link_sms.value"-->
<!--                          :error="inputs.send_link_sms.error"-->
<!--                          :label="$tModeratorMarketingTesting('send_link_sms')"/>-->
<!--            <BaseInputError :value="inputs.send_link_sms.error"/>-->
<!--          </div>-->
          <div class="moderator-marketing-testing__checkbox">
            <BaseCheckbox v-model="inputs.force_send_sms.value"
                          :error="inputs.force_send_sms.error"
                          :label="$tModeratorMarketingTesting('force_send_sms')"/>
            <BaseInputError :value="inputs.force_send_sms.error"/>
          </div>
        </div>
      </div>

      <BaseAlert :value="overallErrorsMix"
                 class="moderator-marketing-testing__error  _warning"/>
      <div class="moderator-marketing-testing__footer">
        <button @click.prevent="onSend"
                class="moderator-marketing-testing__btn-send  base-btn  base-btn--blue">
          {{ $tModeratorMarketingTesting('Send') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import formMixins from '@/mixins/formMixins'
  import ErrorView from '@/components/ErrorView'
  import BaseInputError from '@/components/BaseInputError'
  import FilesUploadMultiple from '@/components/FilesUploadMultiple'
  import handleError from '@/helpers/handleError'
  import {ALLOWED_IMAGES_EXTS, ALLOWED_VIDEOS_EXTS, IMAGES_MIME_TYPES, VIDEOS_MIME_TYPES} from "@/constants/files"

  const Editor = () => import(
    /* webpackChunkName: "editor" */ '@/components/Editor'
    );

  function getInputs() {
    return {
      customer_id: {
        value: null
      },
      admin_id: {
        value: null
      },
      sms: {
        value: null
      },
      bot: {
        value: null
      },
      link_to_bot: {
        value: null
      },
      site: {
        value: null
      },
      email_title: {
        value: null
      },
      email_subject: {
        value: null
      },
      email_link: {
        value: null
      },
      email: {
        value: null
      },
      messenger: {
        value: null
      },
      messenger_link: {
        value: null
      },
      // send_link_bot: {
      //   value: false
      // },
      // send_link_sms: {
      //   value: false
      // },
      force_send_sms: {
        value: false
      },
    }
  }

  export default {
    name: 'AccountModeratorMarketingTestingPage',
    mixins: [formMixins],
    components: {
      ErrorView,
      BaseInputError,
      FilesUploadMultiple,
      Editor,
    },
    data() {
      return {
        pending: false,
        error: null,
        receivedData: null,
        fromPending: false,

        inputs: getInputs(),
        messengerImage: [],

        filesExtsMixin: [...ALLOWED_IMAGES_EXTS, ...ALLOWED_VIDEOS_EXTS],
        filesMimeTypes: [...IMAGES_MIME_TYPES, ...VIDEOS_MIME_TYPES],
      }
    },
    methods: {
      load() {
        this.pending = true

        http.get('/api/backoffice/mailing/test-datalist')
          .then(({data}) => {
            this.receivedData = data.data
          })
          .catch(e => {
            this.error = {
              code: e.response && e.response.status,
              message: handleError(e)
            }
          })
          .finally(() => {
            this.pending = false
          })
      },
      onSend() {
        this.fromPending = true

        this.resetErrorsMix(this.inputs)
        const sendData = this.createSendDataMix(this.inputs)
        const formData = new FormData()

        sendData.admin_id = sendData.admin_id ? sendData.admin_id.key : ''
        sendData.customer_id = sendData.customer_id ? sendData.customer_id.key : ''

        for (const key in sendData) {
          let value = sendData[key]
          value = isEmptyField(value) ? '' : value
          formData.append(key, value)
        }

        formData.append('messenger_image', this.$get(this.messengerImage, '[0].file', ''))

        http.post('/api/backoffice/mailing/send-test', formData)
          .then(() => {
            this.$vModal.open('successfully-sent', {
              title: this.$tModeratorMarketingTesting('successfully_sent_title'),
              text: this.$tModeratorMarketingTesting('successfully_sent_text')
            })

            this.resetForm()
          })
          .catch(e => {
            this.errorHandlerMix(e, this.inputs)
          })
          .finally(() => {
            this.fromPending = false
          })
      },
      resetForm() {
        this.inputs = getInputs()
      }
    },
    created() {
      this.load()
    }
  }

  function isEmptyField(value) {
    return !!(value === null || value === '' || value === undefined)
  }
</script>

<style lang="less">

</style>
